import { render, staticRenderFns } from "./DodOrdersList.vue?vue&type=template&id=cd46befa&scoped=true&"
import script from "./DodOrdersList.vue?vue&type=script&lang=js&"
export * from "./DodOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./DodOrdersList.vue?vue&type=style&index=0&id=cd46befa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd46befa",
  null
  
)

export default component.exports